export function isExtoleRestException(obj) {
    return (typeof obj === "object" &&
        obj !== null &&
        "message" in obj &&
        typeof obj.message === "string" &&
        "unique_id" in obj &&
        typeof obj.unique_id === "string" &&
        "http_status_code" in obj &&
        typeof obj.http_status_code === "number" &&
        "code" in obj &&
        typeof obj.code === "string" &&
        "parameters" in obj &&
        typeof obj.parameters === "object" &&
        obj.parameters !== null);
}
